import AllocationIndex from "./pages/IndexPage.vue";
import AllocationPage from "./pages/AllocationPage";

export default [
  {
    path: "/allocation",
    component: AllocationIndex,
    redirect: "/allocation/index",
    name: "allocate",
    children: [
      {
        path: "index",
        component: AllocationPage,
        name: "job.allocate",
      }
    ],
  },
];
